import { useEffect } from "react";
import MainView from "views/MainView";

import { publicPath } from "request";

export const Download = () => {
  const googlePlayURL = process.env.REACT_APP_GOOGLE_PLAY_URL as string;
  const appStoreURL = process.env.REACT_APP_APPSTORE_URL as string;

  useEffect(() => {
    if (process.env.REACT_APP_IS_FROM_APP === "false") return;
    var agent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    if (
      agent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      var agentName = agent.toLowerCase();
      if (/android/i.test(agentName)) {
        window.location.href = googlePlayURL;
      } else if (/iphone/i.test(agentName)) {
        window.location.href = appStoreURL;
      }
    }
  }, []);

  return (
    <MainView backgroundClassName="bg-white dark:bg-black1b1f1e">
      <img
        src={`${publicPath}/images/download/img_top.png`}
        alt=""
        className="w-full h-fit max-h-[700px]"
      />
      <div className="flex items-center flex-col justify-center">
        <span className="text-sm">Download APP</span>
        <a
          className="w-[250px] h-[54px] bg-primary text-white flex items-center justify-center no-underline rounded-lg mt-6"
          href={appStoreURL}
        >
          <img
            src={`${publicPath}/images/download/ic_ios.png`}
            className="w-full h-full max-w-6 max-h-6 mr-2"
          />
          <span>IOS</span>
        </a>

        <a
          className="w-[250px] h-[54px] bg-primary text-white flex items-center justify-center no-underline rounded-lg mt-4"
          href={googlePlayURL}
        >
          <img
            src={`${publicPath}/images/download/ic_android.png`}
            className="w-full h-full max-w-6 max-h-6 mr-2"
          />
          <span>Android</span>
        </a>
      </div>
    </MainView>
  );
};
